import type {
  ArchiveDocumentInput,
  ArchivedDocument,
  DocumentArchiveGateway,
} from '@forq/contracts';
import type { ForqSupabaseClient } from './client';
import { SupabaseOperationError } from './errors';

/**
 * Belegarchiv gegen `public.document_archive` -- schreib-einmalig, siehe Migration
 * `20260904093000_document_archive.sql`.
 */
export class SupabaseDocumentArchiveGateway implements DocumentArchiveGateway {
  constructor(private readonly client: ForqSupabaseClient) {}

  async archiveDocument(input: ArchiveDocumentInput): Promise<ArchivedDocument> {
    const { data, error } = await this.client.rpc('document_archive_put', {
      p_tenant_id: input.tenantId,
      p_payload: {
        kind: input.kind,
        documentNumber: input.documentNumber,
        contentHtml: input.contentHtml,
        checksum: input.checksum ?? '',
        snapshot: input.snapshot,
      },
    });
    if (error) throw new SupabaseOperationError('documentArchive.put', error.message);
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
      throw new SupabaseOperationError('documentArchive.put', 'Die Ablage lieferte keinen gültigen Archiveintrag.');
    }
    return data as ArchivedDocument;
  }

  async getArchivedDocument(tenantId: string, documentNumber: string): Promise<ArchivedDocument | null> {
    const { data, error } = await this.client.rpc('document_archive_get', {
      p_tenant_id: tenantId,
      p_document_number: documentNumber,
    });
    if (error) throw new SupabaseOperationError('documentArchive.get', error.message);
    if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
    return data as ArchivedDocument;
  }
}
